<template>
<div style="display: flex; gap: 8px; margin-bottom: 24px;">
    <div style="border-radius: 8px; width: 53px; height: 18px; text-align: center;" :style="{'background': currentColor.color}">
        <span style="font-size: 12px; letter-spacing: 0px; color: #FFFFFF; font-family: var(--font-acumin-pro-regular);">{{ apiMethod }}</span>
    </div>
    <div class="container-method-api">
        <div class="url-method scrollmenu1">
                <slot></slot>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'RequestMethod',
    props: {
        apiMethod: {
            type: String,
            default: 'Get'
        },
    },
    data: () => {
        return {
            colors: [
                { color: '#0466BA', code: 'post'},
                { color: '#109066', code: 'get'},
                { color: '#D12940', code: 'delete'},
                { color: '#F7B500', code: 'put'},
            ]
        }
    },
    computed: {
        currentColor: function() {
            return this.colors.find((x) => x.code.toLowerCase() === this.apiMethod.toLowerCase())
        }  
    }
}
</script>
<style>
.url-method {
    font-family: var(--font-acumin-pro-light) !important;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0px;
    color: #606B86;
    p {
        font-family: var(--font-acumin-pro-light) !important;
        font-size: 16px !important;
        font-weight: 300 !important;
        letter-spacing: 0px !important;
        color: #606B86 !important;
    }
}

.container-method-api {
    width: 100%; display: flex; overflow: auto;
}

 .container-method-api::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
}

.scrollmenu1 {
    flex: 0 0 auto;
    background-color: transparent;
}

.scrollmenu1::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
}
</style>